import React, { useState } from 'react';

function ImageGallery() {
  const [selectedImage, setSelectedImage] = useState(null);
  
  const galleryImages = [
    {
      id: 1,
      title: "Modern Architecture",
      category: "Architecture",
      image: "https://images.unsplash.com/photo-1519662978799-2f05096d3636?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzQ5MDQwMTI0fDA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Marten Bjork", url: "https://unsplash.com/@martenbjork?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 2,
      title: "Startup Office",
      category: "Workspace",
      image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwxfHxzdGFydHVwJTIwb2ZmaWNlfGVufDB8fHx8MTc0OTA0MDEyNHww&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Austin Distel", url: "https://unsplash.com/@austindistel?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 3,
      title: "Creative Team",
      category: "Team",
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHRlYW18ZW58MHx8fHwxNzQ5MDQwMTI0fDA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Marvin Meyer", url: "https://unsplash.com/@marvelous?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 4,
      title: "Business Success",
      category: "Business",
      image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHN1Y2Nlc3N8ZW58MHx8fHwxNzQ5MDQwMTIzfDA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "krakenimages", url: "https://unsplash.com/@krakenimages?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 5,
      title: "Modern Workspace",
      category: "Workspace",
      image: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzQ5MDQwMTIzfDA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Toa Heftiba", url: "https://unsplash.com/@heftiba?utm_source=makerdevi&utm_medium=referral" }
    },
    {
      id: 6,
      title: "Team Collaboration",
      category: "Team",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHw0fHxjcmVhdGl2ZSUyMHRlYW18ZW58MHx8fHwxNzQ5MDQwMTI0fDA&ixlib=rb-4.1.0&q=80&w=1080",
      attribution: { name: "Jason Goodman", url: "https://unsplash.com/@jasongoodman_youxventures?utm_source=makerdevi&utm_medium=referral" }
    }
  ];

  return (
    <div className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Portfolio</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our recent projects and see how we've helped businesses transform their digital presence
          </p>
        </div>
        
        {/* Masonry Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((item, index) => (
            <div 
              key={item.id} 
              className={`group relative cursor-pointer overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 ${
                index % 3 === 0 ? 'md:row-span-2' : ''
              }`}
              onClick={() => setSelectedImage(item)}
            >
              <img 
                src={item.image} 
                alt={item.title}
                className={`w-full object-cover group-hover:scale-105 transition-transform duration-300 ${
                  index % 3 === 0 ? 'h-96' : 'h-64'
                }`}
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 text-white">
                  <span className="text-sm bg-green-600 px-2 py-1 rounded-full">{item.category}</span>
                  <h3 className="text-lg font-semibold mt-2">{item.title}</h3>
                </div>
              </div>
              
              {/* Image Attribution */}
              <span className="group/attribution absolute bottom-2 right-2 text-[10px] text-white outline outline-1 outline-white px-[6px] rounded-lg z-10 min-w-4 max-w-[calc(100%-16px)] h-4 leading-4 truncate text-center shadow">
                <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
                <span className="hidden drop-shadow-md group-hover/attribution:block">
                  Image on{' '}
                  <a
                    href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#fff', textDecoration: 'none' }}
                  >
                    Unsplash
                  </a>{' '}
                  by{' '}
                  <a
                    href={item.attribution.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#fff', textDecoration: 'none' }}
                  >
                    {item.attribution.name}
                  </a>
                </span>
              </span>
            </div>
          ))}
        </div>
        
        {/* Lightbox Modal */}
        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-4xl max-h-full">
              <img 
                src={selectedImage.image} 
                alt={selectedImage.title}
                className="max-w-full max-h-full object-contain"
              />
              <button 
                className="absolute top-4 right-4 text-white text-2xl hover:text-gray-300"
                onClick={() => setSelectedImage(null)}
              >
                ✕
              </button>
              <div className="absolute bottom-4 left-4 text-white">
                <span className="text-sm bg-green-600 px-2 py-1 rounded-full">{selectedImage.category}</span>
                <h3 className="text-xl font-semibold mt-2">{selectedImage.title}</h3>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ImageGallery;